import React from "react"

import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./newsletter-rich-text.module.scss"
import DarkColor from "../../../helpers/dark-color"
import CopyContainer from "../../atoms/copy-container"
import Heading from "../../atoms/heading"

const NewsletterRichText = ({ section, styling }) => (
  <div
    className={`${styles.wrapper} ${section.closed ? `${styles.wrapper__contain} ${styles[`wrapper__${section.color.replaceAll("-", "")}`]}` : ""}`}
  >
    <CopyContainer className={styles.container}>
      {section.title ? (
        <div
          className={`${styling === "lifestyle" ? styles.title__lifestyle : ""} ${section.title_centered ? styles.center : ""}`}
        >
          {section.icon ? (
            <div className={styles.icon}>
              <Image {...section.icon?.image} width={60} height={60} alt="" />
            </div>
          ) : (
            ""
          )}
          <div className={styles.titleInner}>
            {section.subtitle ? (
              <Heading level={6}>{section.subtitle}</Heading>
            ) : (
              ""
            )}
            {styling === "lifestyle" ? (
              <div className={styles.titleText}>{section.title}</div>
            ) : (
              <Heading level={4}>{section.title}</Heading>
            )}
          </div>
          {section.icon ? (
            <div className={styles.icon}>
              <Image {...section.icon?.image} width={60} height={60} alt="" />
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
      <CopyContainer
        className={styling === "lifestyle" ? styles.content : ""}
        content={section._rawContent}
        light={DarkColor(section.color)}
      />
    </CopyContainer>
  </div>
)

export default NewsletterRichText

NewsletterRichText.propTypes = {
  section: PropTypes.object.isRequired,
  styling: PropTypes.string,
}

NewsletterRichText.defaultProps = {
  styling: "",
}
